<template>
  <b-modal id="success-modal-backbeat">
    <b-container>
      <template #modal-header></template>

      <b-row class="my-3">
        <div class="success-container">
          <h2>{{ this.$props.title }}</h2>
        </div>
      </b-row>
      <div>
        <div>
          <!-- case: RT -->
          <div v-if="this.$props.typeAction == 'RT'">
            <p class="p1 mb-5">
              <strong>
                Importante:
              </strong>
              Os resultados acima contemplam apenas beneficiários da Grande
              Florianopólis que possuem planos privados de assistência à
              saúde na modalidade de pré-pagamento.
            </p>
          </div>
          <!-- case: MT -->
          <div v-if="this.$props.typeAction == 'MT'">
            <p class="p1 mb-5">
              A meta foi determinada levando em consideração os esforços
              coletivos e qualidade assistencial dos médicos cooperados.
            </p>
          </div>
          <!-- case: IS -->
          <div v-if="this.$props.typeAction == 'IS'">
            <p class="p1 mb-5" v-text="onTextLossRatio()"></p>
          </div>
          <!-- case: IA -->
          <div v-if="this.$props.typeAction == 'IA'">
            <p class="p1">
              <strong>CUMPRIMENTO DA PRODUÇÃO MÍNIMA:</strong> o cooperado
              deverá obter a produção mínima nas últimas 12 competências
              (conforme o Regimento Interno Art. 138).
            </p>
            <p class="p1">
              <strong>PARTICIPAÇÃO ASSEMBLEIA:</strong> o cooperado deverá
              participar da última assembleia para receber o ganho adicional
              até a próxima assembleia e assim sucessivamente.
            </p>
            <p class="p1 mb-1">
              <strong>OBRIGAÇÕES FINANCEIRAS:</strong> o cooperado deverá
              estar adimplente com todas as obrigações financeiras com a
              cooperativa (mensalidade e coparticipação do plano de saúde,
              seguros, alugueis, cota capital e etc).
            </p>
            <p class="p-16-custom mb-5">
              <strong>Ganho adicional máximo do indicador: 1,00% </strong>
            </p>
          </div>
        </div>
      </div>
    </b-container>
    <template #modal-footer>
      <b-button
        @click="$bvModal.hide('success-modal-backbeat')"
        class="ml-4"
        variant="primary"
      >
        {{ $props.buttonText ? $props.buttonText : "Ok" }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: ["buttonText", "title", "typeAction",  "isLossRatio", "goal", "lossRatio"],
  methods: {
    onTextLossRatio() {
      if (this.$props.isLossRatio)
        return `O índice de sinistralidade foi de ${this.$props.lossRatio}, ultrapassando 
                     o valor máximo de ${this.$props.goal} necessário para atingir a meta.`;
      else
        return `O indice de sinistralidade foi de ${this.$props.lossRatio}, mantendo um valor
                      menor que ${this.$props.goal}, assim atingindo a meta.`;
    },
  }
};
</script>

<style lang="scss"></style>
